// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3u733","index":"styles_index__1o1kx"};